import React from 'react';

import { Modal } from '../../../../../../../../components';

import { whiteWarning } from '../../../../../../../../assets/Base64Image';

import {
  OkeyBtn, Column,
} from './Styles';

const NoticeModal: React.FC<Props> = ({
  onClose,
  isEnglish,
}) => {
  return (
    <Modal
      style={{ width: '275px', padding: 'unset', textAlign: 'center', paddingBottom: '26px', borderRadius: '22px' }}
    >
      {/* 图标 */}
      <Column style={{ width: '84px', height: '84px', marginTop: '-40px', marginLeft: 'auto', marginRight: 'auto', background: '#11202B', borderRadius: '50%' }}>
        <img src={whiteWarning} style={{ width: '42px', height: '38px' }} />
      </Column>
      {
        isEnglish ? (
          <div style={{ marginTop: '20px', fontSize: '22px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#11202B' }}>
            Notice
          </div>
        ) : (
          <div style={{ marginTop: '20px', fontSize: '22px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#11202B' }}>
            注意
          </div>
        )
      }
      {
        isEnglish ? (
          <div style={{ margin: '20px auto 0 auto', fontSize: '16px', fontFamily: 'Squad-Regular, Squad', fontWeight: 400, color: '#11202B', lineHeight: '24px', textAlign: 'center', width: '236px' }}>
            To rent a locker, you must enter <br /> the recipients’ unit number.
          </div>
        ) : (
          <div style={{ margin: '20px auto 0 auto', fontSize: '16px', fontFamily: 'PingFangSC-Regular, PingFang SC', fontWeight: 400, color: '#11202B', lineHeight: '24px', textAlign: 'center', width: '236px' }}>
            您必须输入收件人的门牌号才可以租用智能柜。
          </div>
        )
      }
      {/* Okay按钮 */}
      <OkeyBtn onClick={() => onClose()}>
        {
          isEnglish ? (
            <div style={{ fontSize: '16px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#FFFFFF', lineHeight: '21px' }}>
              Okay
            </div>
          ) : (
            <div style={{ fontSize: '16px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#FFFFFF', lineHeight: '22px' }}>
              好的
            </div>
          )
        }
      </OkeyBtn>
    </Modal>
  );
};

export interface Props {
  onClose: () => void;
  isEnglish: boolean;
}

export default NoticeModal;
